<div>
    <mat-card-content>
        <div class="text-right">
            <div class="nav-btn add-btn" *ngIf="role<=3">
                <button mat-button [matMenuTriggerFor]="addMenu">
                    <mat-icon>add</mat-icon> Add
                </button>
                <mat-menu #addMenu="matMenu" yPosition="below">
                    <button mat-menu-item (click)="addDeviceClick()">Device</button>
                    <button mat-menu-item (click)="addDomainClick()" *ngIf="role<=2">Domain</button>
                    <button mat-menu-item (click)="addUserClick()">User</button>
                </mat-menu>
            </div>

            <mat-form-field class="example-form-field">
                <mat-label>Search Here ...</mat-label>
                <input matInput type="text" [(ngModel)]="searchTxt" (keyup.enter)="searchData()" autocomplete="off">
                <button mat-button *ngIf="searchTxt" matSuffix mat-icon-button aria-label="Clear"
                    (click)="searchTxt='';searchData();">
                    <mat-icon>close</mat-icon>
                </button>
            </mat-form-field>
        </div>

        <app-users-table [dataSource]="dataSource" (refresh)="loadData()" [selfSort]="true"></app-users-table>
    </mat-card-content>
</div>